module.exports = __webpack_public_path__ + "img/CRC2_B.78657ad1.png";